declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { NgbDateStruct, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbRegisteredPatientModal } from './modal/registeredpatient.modal';
import { NgbGuestPatientModal } from './modal/guestpatient.modal';
import { NgbTypeofPatientModal } from './modal/typeofpatient.modal';
import {
  DoctorsListController, DoctorAppointmentsByDoctorcodeContoller,
  DoctorAppointmentsByDoctorCodeRequest, AppointmentDetailsByAppointmentCodeController,
  AppointmentDetailsByAppointmentCodeRequest, DoctorsListRequest,
  ProviderAvlSlotsRequest, ProviderAvlSlotsController, AppointmentCancelRequest,
  SavePatientVisitRequest, SavePatientInfoRequest, DoctorAppointmentsByDoctorCode2Request,
  DoctorAppointmentsByDoctorcode2Contoller, AppointmentsInWeek, SlotsInDay, Appt
} from '../../../models/actor/actor';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ActorService } from '../../../services/actor.service';
import { SpinnerService } from '../../../services/spinner.service';
import { DoctorListPipe, PatientListPipe, PatientListPipe2 } from '../../../pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { NgbSel_ApptdetailsModal } from './sel_apptdetails.modal';

@Component({
  selector: 'app-fdappointmentadv',
  templateUrl: './fdappointment(adv).component.html',
  styleUrls: ['./fdappointment(adv).component.css']
})
export class FdappointmentAdvComponent implements OnInit {
  public ActorCode: number = 0;
  public ShowList: boolean = true;
  public ShowList1: boolean = true;
  public ShowList2: boolean = true;
  public AvailableSlots: boolean = true;
  public User: boolean = false;
  public ShowButton: boolean = true;
  public PatientDetails: boolean = false;
  public Final: boolean = false;
  public BranchName: string;
  public Final1: boolean = false;
  public Registeredpatient: boolean = false;
  public Regconfirm: boolean = false;
  public AppList: boolean = false;
  public isLoading: boolean = false;
  public PresentDate: Date;
  public DateSelected: Date;
  public ChangedDate: Date;
  DateOfBirth: NgbDateStruct;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  WeddingAn: NgbDateStruct;
  DateOfBirthFemale: NgbDateStruct;
  DateOfBirthMale: NgbDateStruct;
  FemaleDateofBirth: NgbDateStruct;
  public DisplayPresentDate: boolean = true;
  public DisplaySelectedDate: boolean = false;
  public DisplayChangedDate: boolean = false;
  SelectedFromDate: NgbDateStruct;
  public SelectedDatenew: Date;
  TodayDate = new Date();
  ValidFrom: NgbDateStruct;
  CurrentSavePatientVisitInformationRequest: SavePatientVisitRequest;
  CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  CurrentAppointmentCancelRequest: AppointmentCancelRequest;
  constructor(private actorservice: ActorService,
    private loaderService: SpinnerService,
    private filter: DoctorListPipe,
    private filter1: PatientListPipe2,
    private tosterservice: NGXToastrService,
    private parserFormatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private router: Router

  ) { }

  ngOnInit() {
    //     this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    //this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.PresentDate = new Date();
    // this.LoadDoctorsList();
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.SelectedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.LoadDoctorsList(this.SelectedFacilityCode);
    this.CurrentAppointmentCancelRequest = new AppointmentCancelRequest();

    this.CurrentAppointmentCancelRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSavePatientVisitInformationRequest = new SavePatientVisitRequest();

    this.CurrentSavePatientVisitInformationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSavePatientInfoRequest = new SavePatientInfoRequest();
    this.CurrentSavePatientInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentSavePatientVisitInformationRequest = new SavePatientVisitRequest();

    //this.CurrentSavePatientVisitInformationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }
  viewservice() {
    this.ShowList = true;
    //this.ShowList1 = true;
    this.AvailableSlots = true;
    this.ShowButton = false;
    this.ShowList2 = false;
    this.User = false;
  }
  applist() {
    this.ShowList = true;
    this.AvailableSlots = true;
    this.AppList = true;
    this.ShowList1 = false;
    this.ShowList2 = false;
    this.ShowButton = false;
    this.User = false;
  }
  applist1() {
    this.ShowList = true;
    this.AvailableSlots = true;
    this.AppList = false;
    this.ShowList1 = true;
    this.ShowList2 = false;
    this.ShowButton = false;
    this.User = false;
  }
  Patient1() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = true;
  }
  guestpatient() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = true;
  }
  regpatient() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Registeredpatient = true;
    this.Final = false;
    this.Final1 = false;
  }
  BacktoList() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = true;
    this.PatientDetails = false;
  }
  Confirm() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Final = true;
  }
  Confirm1() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Final1 = true;
    this.Final = false;
    this.Regconfirm = false;
  }
  regconfirm() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Regconfirm = true;
    this.Final = false;
    this.Registeredpatient = false;
  }
  BacktoList1() {
    this.ShowList = true;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Final = false;
  }
  Patient() {
    const modalRef = this.modalService.open(NgbTypeofPatientModal,
      {
        centered: true,
        size: "lg"
      })
  }
  public SelectedSlots: ProviderAvlSlotsController;
  public selectedGroup: any;
  SelectedSlotDetails(SlotNumber: number) {
    //alert(SlotNumber);
    //this.SelectedSlots = p;
    //alert(this.SelectedSlots.StartDate);
  }
  onChange(Event: any) {
    //if (Event != null) {
    //    var a = this.CurrentDSAActivityByCycleCodeController.filter(X => X.DSA === Event)
    //    if (a.length > 0) {
    //        this.ActivityDate = a[0].ActivityDate;

    //    }

    //}
    //alert(Event);
    //alert(this.selectedGroup)
  }
  regpatientmodal(selectedGroup: ProviderAvlSlotsController) {
    const modalRef = this.modalService.open(NgbRegisteredPatientModal,
      {
        centered: true,
        size: "lg"
      })

    modalRef.componentInstance.ProviderAvlSlotsController = selectedGroup;
    modalRef.componentInstance.SelectedDoctor = this.SelectedDoctorData;
    //modalRef.componentInstance.FormattedCode = 
    modalRef.result.then(x => {
      this._GetProviderAvlSlotsContoller();
      this.LoadDoctorAppointmentsByDoctor();
      //    this.GetIvfPlanTemplateController()
    })

  }
  guestpatientmodal() {
    const modalRef = this.modalService.open(NgbGuestPatientModal,
      {
        centered: true,
        size: "lg"
      })
  }

  ProviderSlots: ProviderAvlSlotsController[];
  // ProviderSlots2: ProviderAvlSlotsController[];
  CurrentDoctorAppointmentsByDoctorcodeController: DoctorAppointmentsByDoctorcode2Contoller[];
  CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest: DoctorAppointmentsByDoctorCode2Request;
  SelectedAppointmentDetailsByAppointmentCodeController: AppointmentDetailsByAppointmentCodeController[];
  SelectedAppointmentDetails: AppointmentDetailsByAppointmentCodeController;
  LoadDoctorAppointmentsByDoctor() {
    if (this.CalendarView) {
      this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcode2Contoller>();

      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCode2Request();
      this.pdata1 = this.GetSelectedDateAppts();//this.CurrentDoctorAppointmentsByDoctorcodeController;
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;

      //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
      this._GetDoctorAppointmentsByDoctorcodeForWeekContoller();
    }
    else {

      this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcode2Contoller>();

      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCode2Request();
      this.pdata1 = this.GetSelectedDateAppts();//this.CurrentDoctorAppointmentsByDoctorcodeController;
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 115;

      //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
      this._GetDoctorAppointmentsByDoctorcodeContoller();

    }
  }

  SelectedApptData: DoctorAppointmentsByDoctorcode2Contoller;
  AppointmentsListItemSelected(data: DoctorAppointmentsByDoctorcode2Contoller, statusText: string, e) {
    //alert("appointment selected: " + data.PatientName);
    this.DoctorsList = true;
    this.SelectedDoctor = true;
    this.SelectedPatient = true;
    this.SelectedApptData = data;
    this.LoadAppointmentDetailsByAppointmentCode(data.AppointmentCode, statusText, e);

  }
  LoadAppointmentDetailsByAppointmentCode(AppointmentCode: number, statusText: string, e) {
    var request: AppointmentDetailsByAppointmentCodeRequest = new AppointmentDetailsByAppointmentCodeRequest();
    request.ConditionalOperator = 10;
    request.AppointmentCode = AppointmentCode;
    request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetAppointmentDetailsByAppointmentCodeContoller(request, statusText, e);

  }

  GetAppointmentDetailsByAppointmentCodeContoller(request: AppointmentDetailsByAppointmentCodeRequest, statusText: string, e) {
    // alert(this.SelectedDoctorData.ProviderCode);
    //this.StartRefreshing();
    this.actorservice.GetAppointmentDetailsByAppointmentCodeContoller(request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.SelectedAppointmentDetailsByAppointmentCodeController = this.ApiResData.Result;
          //alert(this.SelectedAppointmentDetailsByAppointmentCodeController.length);
          if (this.SelectedAppointmentDetailsByAppointmentCodeController.length > 0)
            this.SelectedAppointmentDetails = this.SelectedAppointmentDetailsByAppointmentCodeController[0];
          //this.onSubmit(statusText,e)

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  GetDoctorAppointmentsByDoctorcodeContoller() {
    // alert(this.SelectedDoctorData.ProviderCode);
    //this.StartRefreshing();
    this.isLoading = true;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result;
          this.pdata1 = this.GetSelectedDateAppts();// this.CurrentDoctorAppointmentsByDoctorcodeController;
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);
          this.isLoading = false;
          //this.stopRefreshing();
          //this.LoadAppoinmentDate();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  //    AppoinmentData: DoctorAppointmentsByDoctorcodeContoller[];
  //    LoadAppoinmentDate() {
  //        this._GetDoctorAppointmentsByDoctorcodeContollernew();
  //    }
  //    _GetDoctorAppointmentsByDoctorcodeContollernew() {
  //    // alert(this.SelectedDoctorData.ProviderCode);
  //        this.StartRefreshing();
  //        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
  //    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
  //    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
  //    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
  //        .subscribe((result) => {
  //            this.ApiResData = result;
  //            if (!this.ApiResData.hasError) {

  //                //alert();
  //                this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result;
  //                this.AppoinmentData = this.ApiResData.Result;
  //                //this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
  //                // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

  //                this.stopRefreshing();

  //            }
  //            else {
  //                this.stopRefreshing();
  //                if (this.ApiResData.ErrorData != "") {

  //                    alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //                }
  //                else {
  //                    alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //                }
  //            }

  //        },


  //            (error) => {

  //                if (error == "401 - Unauthorized") {
  //                    alertFunctions.AlertParamEr(error);
  //                    this.stopRefreshing();



  //                }
  //                else {
  //                    alertFunctions.AlertParamEr(error);
  //                    this.stopRefreshing();
  //                }
  //            }


  //        );

  //}
  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;
  ProviderAvlSlotsRequest: ProviderAvlSlotsRequest;

  dataChanged(newobj) {
    //this.ChangedDate = newobj;
    //  this.DisplayPresentDate = false;
    //  this.DisplaySelectedDate = false;
    //  this.DisplayChangedDate = true;
    //  this._GetProviderAvlSlotsContoller();
    //this._GetDoctorAppointmentsByDoctorcodeContoller();
    this.RefresAppts();
  }
  _GetProviderAvlSlotsForWeekContoller() {
    //  alert("load slots...")
    // this.spinner.show()
    this.ProviderAvlSlotsRequest = new ProviderAvlSlotsRequest();
    this.ProviderAvlSlotsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ProviderAvlSlotsRequest.ConditionalOperator = 10;
    this.ProviderAvlSlotsRequest.Duration = 15;
    this.ProviderAvlSlotsRequest.FacilityCode = this.SelectedFacilityCode;
    this.ProviderAvlSlotsRequest.Branch = this.SelectedFacilityCode;
    this.ProviderAvlSlotsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //alert(this.ProviderAvlSlotsRequest.FromDate);
    this.ChangedDate = this.ProviderAvlSlotsRequest.FromDate;
    this.DateSelected = this.ProviderAvlSlotsRequest.FromDate;
    this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.ProviderAvlSlotsRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (7 * 60 * 60 * 24 * 1000));
    //new Date((new Date()).getTime() + (60 * 60 * 24 * 1000));
    // alert(this.SelectedDoctorData.ProviderCode);
    //this.StartRefreshing();
    this.ProviderAvlSlotsRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetProviderAvlSlotsContoller(this.ProviderAvlSlotsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.ProviderSlots = this.ApiResData.Result;
          // this.spinner.hide();
          //  this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

          this.stopRefreshing();
          this._GetDoctorAppointmentsByDoctorcodeForWeekContoller();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  _GetProviderAvlSlotsContoller() {
    //  alert("load slots...")
    // this.spinner.show()
    this.ProviderAvlSlotsRequest = new ProviderAvlSlotsRequest();
    this.ProviderAvlSlotsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ProviderAvlSlotsRequest.ConditionalOperator = 110;
    this.ProviderAvlSlotsRequest.Duration = 15;
    this.ProviderAvlSlotsRequest.FacilityCode = this.SelectedFacilityCode;
    this.ProviderAvlSlotsRequest.Branch = this.SelectedFacilityCode;
    this.ProviderAvlSlotsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //alert(this.ProviderAvlSlotsRequest.FromDate);
    this.ChangedDate = this.ProviderAvlSlotsRequest.FromDate;
    this.DateSelected = this.ProviderAvlSlotsRequest.FromDate;
    this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.ProviderAvlSlotsRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (60 * 60 * 24 * 1000));
    //new Date((new Date()).getTime() + (60 * 60 * 24 * 1000));
    // alert(this.SelectedDoctorData.ProviderCode);
    //this.StartRefreshing();
    this.ProviderAvlSlotsRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetProviderAvlSlotsContoller(this.ProviderAvlSlotsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.ProviderSlots = this.ApiResData.Result;
          // this.spinner.hide();
          //  this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  _GetDoctorAppointmentsByDoctorcodeForWeekContoller() {
    // alert(this.SelectedDoctorData.ProviderCode);
    //this.StartRefreshing();
    this.isLoading = true;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
    //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result;
          this.pdata1 = this.GetSelectedDateAppts();//this.CurrentDoctorAppointmentsByDoctorcodeController;
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);
          this.isLoading = false;
          //this.stopRefreshing();
          // convert both into calendar view specific instances...
          this.Mashup_AvailableSlots_and_FilledSlots(
            this.ProviderSlots,
            this.CurrentDoctorAppointmentsByDoctorcodeController);

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }




  CalendarDays: Date[] = [];

  AppointmentsInWeek: AppointmentsInWeek[] = [];
  // ApptSlot: ApptSlot[] =[];c
  //Appt:  Appt[] =[];
  GotoDailyView(c: any) {
    var obj = new Date(c);// da as Date;
    //alert(obj.getFullYear());

    //var dat = new Date(obj.get .toDateString());

    //var monthNo = this.SelectedFromDate.month;
    //var d: Date = new Date(
    //  this.SelectedFromDate.year,
    //  monthNo - 1,
    //  this.SelectedFromDate.day
    //);
    //if (obj.getFullYear() == this.SelectedFromDate.year &&
    //  obj.getMonth() + 1 == this.SelectedFromDate.month &&
    //  obj.getDate() == this.SelectedFromDate.day) 
    //var monthNo = this.SelectedFromDate.month
    //var d: Date = new Date(
    //  this.SelectedFromDate.year,
    //  monthNo - 1,
    //  this.SelectedFromDate.day
    //);

    //d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    var d = obj;
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };

    //this.SelectedFromDate.year = d.getFullYear();
    //this.SelectedFromDate.month = d.getMonth() + 1;
    //this.SelectedFromDate.day = d.getDate();

    //     = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.SwitchView();



  }

  TryBookAppt(dayNo: number, slotNo: number) {
    var dayslots = this.AppointmentsInWeek[dayNo].DaySlots.filter(x => x.SlotCode == slotNo);
    // dayslots[0]; slot info
    // provider info
    // open the appointment booking screen..

    var selectedGroup = this.ProviderSlots.filter(x => x.StartDateShort == dayslots[0].AppointmentDate && x.SlotNo == slotNo)[0];
    this.regpatientmodal(selectedGroup);

  }
  TimeLine: Date[] = [];
  TL: Map<number, string> = null;//new Map<number, string>();
  TLKeys: number[] = [];// IterableIterator<number>;
  floattoint(value) {
    return value | 0;
  }

  GetTimeLine() {

    this.TLKeys = [];
    //this.TimeLine = [];
    //var startTime = new Date();
    //startTime.setHours(this.Min_Slot / 4);

    //this.TimeLine.push(startTime);

    var tlset = new Map<number, string>();
    for (var x = this.Min_Slot; x < this.Max_Slot; x += 1) {
      var n: number = this.floattoint(((x - 1) / 4));
      var r: number = ((x - 1) % 4) * 15;
      tlset.set(x, n.toString() + ' : ' + r.toString());



      //var startTime = new Date();
      //startTime.setHours(x / 4);
      //this.TimeLine.push(startTime);      
    }
    this.TL = tlset;
    this.TL.forEach((v, k, m) => {
      this.TLKeys.push(k);
    });

  }
  GetApptsOfDay(dayNo: number, slotNo: number) {
    try {
      var dayslots = this.AppointmentsInWeek[dayNo].DaySlots.filter(x => x.SlotCode == slotNo);
      if (dayslots.length > 0)
        return dayslots[0].FilledSlots;
    }
    catch
    {
      // something wrong.. 
    }
    return null; // reutrn empty array

  }
  Mashup_AvailableSlots_and_FilledSlots(ProviderSlots: ProviderAvlSlotsController[],
    CurrentDoctorAppointmentsByDoctorcodeController: DoctorAppointmentsByDoctorcode2Contoller[]) {
    this.CalendarDays = [];

    this.AppointmentsInWeek = [];

    this.TL = null;

    this.Min_Slot = -1;
    this.Max_Slot = -1;
    //AppointmentsInWeek
    this.ProviderSlots.forEach(x => {

      if (this.Min_Slot == -1)
        this.Min_Slot = x.SlotNo;
      else
        if (x.SlotNo < this.Min_Slot)
          this.Min_Slot = x.SlotNo;

      if (x.SlotNo > this.Max_Slot)
        this.Max_Slot = x.SlotNo;

      var aiw: AppointmentsInWeek = null;
      var n = this.CalendarDays.filter(et => et == x.StartDateShort).length;
      if (n == 0) {
        this.CalendarDays.push(x.StartDateShort);
        //alert(x.StartDateShort);
        aiw = new AppointmentsInWeek();
        aiw.Branch = x.facility;
        aiw.Provider = x.provider;
        aiw.StartDate = x.StartDateShort;
        this.AppointmentsInWeek.push(aiw);
      }
      else {
        aiw = this.AppointmentsInWeek.filter(et => et.StartDate == x.StartDateShort)[0];
        this.AddSlotToWeek(aiw, x);
      }

    }); // end foreach
    //alert(this.Min_Slot);
    //alert(this.Max_Slot);
    this.GetTimeLine();
    //alert(this.CalendarDays.length);
    //SlotsInDay
    //this.AppointmentsInWeek.forEach(aiw => {
    //  var _SlotsInDay: SlotsInDay[] = [];
    //  this.ProviderSlots
    //    .filter(y => y.StartDateShort = aiw.StartDate)
    //    .forEach(x =>    
    //      {          
    //        var sid = new SlotsInDay();
    //        sid.AppointmentDate = x.StartDateShort;
    //        sid.AppointmentTime = x.StartDate;
    //        sid.SlotCode = x.SlotNo;
    //      _SlotsInDay.push(sid);

    //      var _Appt: Appt[] = [];
    //      CurrentDoctorAppointmentsByDoctorcodeController.filter(
    //        a => a.AppointmentDate == x.StartDate).forEach(y => {
    //          var appt = new Appt();
    //          appt.AppointmentTime = y.AppointmentDate;
    //          appt.AppointmentStatus = y.AppointmentStatus;
    //          appt.PatientName = y.PatientName;
    //          appt.SlotCode = x.SlotNo;
    //          appt.PatientFormattedCode = y.PatientFormattedCode;
    //          _Appt.push(appt);             
    //        });
    //      sid.FilledSlots = _Appt;

    //    }); // end foreach
    //  aiw.DaySlots = _SlotsInDay;


    //  //aiw.DaySlots.forEach(ds => {
    //  //  _Appt: Appt[] = [];
    //  //  this.ProviderSlots
    //  //    .filter(y => y.StartDateShort == ds.AppointmentDate && y.StartDate == ds.AppointmentTime)
    //  //    .forEach(x => {


    //  //    }); // end foreach


    //  //}); // end day slots

    //});   // end appt in weeks

    //ApptSlot
    //Appt
  }
  AddSlotToWeek(aiw: AppointmentsInWeek, x: ProviderAvlSlotsController) {
    var _SlotsInDay: SlotsInDay[] = [];
    var sid = new SlotsInDay();
    sid.AppointmentDate = x.StartDateShort;
    sid.AppointmentTime = x.StartDate;
    sid.SlotCode = x.SlotNo;

    if (aiw.DaySlots == null ||
      aiw.DaySlots.length == 0 //||
      // aiw.DaySlots.filter(ds => ds.AppointmentDate == x.StartDateShort).length == 0
    ) {


      aiw.DaySlots = _SlotsInDay;
    }
    //  else {
    //  _SlotsInDay = aiw.DaySlots.filter(ds => ds.AppointmentDate == x.StartDateShort);

    //}
    aiw.DaySlots.push(sid);

    this.AddApptToSlot(sid, x);
    //this.SlotToDay(_SlotsInDay, aiw, x)

    //  this.ProviderSlots
    //    .filter(y => y.StartDateShort = aiw.StartDate)
    //    .forEach(x =>    
    //      {          
    //        var sid = new SlotsInDay();
    //        sid.AppointmentDate = x.StartDateShort;
    //        sid.AppointmentTime = x.StartDate;
    //        sid.SlotCode = x.SlotNo;
    //      _SlotsInDay.push(sid);

    //      var _Appt: Appt[] = [];
    //      CurrentDoctorAppointmentsByDoctorcodeController.filter(
    //        a => a.AppointmentDate == x.StartDate).forEach(y => {
    //          var appt = new Appt();
    //          appt.AppointmentTime = y.AppointmentDate;
    //          appt.AppointmentStatus = y.AppointmentStatus;
    //          appt.PatientName = y.PatientName;
    //          appt.SlotCode = x.SlotNo;
    //          appt.PatientFormattedCode = y.PatientFormattedCode;
    //          _Appt.push(appt);             
    //        });
    //      sid.FilledSlots = _Appt;

    //    }); // end foreach
    //  aiw.DaySlots = _SlotsInDay;
  }
  AddApptToSlot(sid: SlotsInDay, x: ProviderAvlSlotsController) {
    var _Appt: Appt[] = [];
    this.CurrentDoctorAppointmentsByDoctorcodeController.filter(
      a => sid.AppointmentTime == a.AppointmentDate).forEach(y => {
        var appt = new Appt();
        appt.AppointmentTime = y.AppointmentDate;
        appt.ApptCode = y.AppointmentCode;
        appt.AppointmentStatus = y.AppointmentStatus;
        appt.PatientName = y.PatientName;
        appt.SlotCode = x.SlotNo;
        appt.PatientFormattedCode = y.PatientFormattedCode;
        _Appt.push(appt);
        //alert(_Appt.length);
      });

    sid.FilledSlots = _Appt;
  }
  Min_Slot: number;
  Max_Slot: number;

  _GetDoctorAppointmentsByDoctorcodeContoller() {
    // alert(this.SelectedDoctorData.ProviderCode);
    //this.StartRefreshing();
    this.isLoading = true;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 115;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
    //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result;
          this.pdata1 = this.GetSelectedDateAppts();// this.CurrentDoctorAppointmentsByDoctorcodeController;                  
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);
          this.isLoading = false;
          //this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  RefreshAll() {
    this.LoadDoctorAppointmentsByDoctor();
  }

  LoadDoctorsList(SelectedFacility: number) {
    const facility = Number(SelectedFacility) || Number(this.SelectedFacilityCode) || AppData.Instance().SelectedBranchCode || 1;
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    this.pdata = this.CurrentDoctorsListController;
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = facility;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result;
          this.pdata = this.CurrentDoctorsListController;
          if (this.pdata && this.pdata.length > 0 && !this.SelectedDoctorData) {
            this.DoctorListItemSelected(this.pdata[0]);
          }

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  SelectedDoctorData: DoctorsListController;
  DoctorListItemSelected(doctor: DoctorsListController) {
    this.SelectedDoctorData = doctor;
    // alert(this.SelectedDoctorData.DisplayName);
    this.DoctorsList = true;
    this.SelectedDoctor = true;
    this.SelectedPatient = false;

    // show selected doctor info..
    // if any speciffics are requried...
    // load doctor's appointments of today, default
    if (!this.CalendarView) {
      this.LoadDoctorAppointmentsByDoctor();
      //this.DisplayPresentDate = true;
      //this.DisplaySelectedDate = false;
      this._GetProviderAvlSlotsContoller();
    }
    else {
      //this.LoadDoctorAppointmentsByDoctor();
      // get slots => will call (get filled slots)
      //this.DisplayPresentDate = false;
      //this.DisplaySelectedDate = true;
      this._GetProviderAvlSlotsForWeekContoller();
    }

  }
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public DoctorsList: boolean = true;
  public SelectedDoctor: boolean = false;
  public SelectedPatient: boolean = false;
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  pdata: any[];
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentDoctorsListController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentDoctorsListController, this.listFilter);
      }
    }
  }

  pdata1: DoctorAppointmentsByDoctorcode2Contoller[];
  listFilter1: string;
  ngOnChanges1(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata1 = this.GetSelectedDateAppts();

    this.criteriaChange1(this.listFilter1);
  }
  criteriaChange1(value: any) {
    if (this.filter1 != null) {
      if (value != '[object Event]') {
        this.listFilter1 = value;
        //alert(this.listFilter);
        this.pdata1 = this.filter1.transform(this.GetSelectedDateAppts(), this.listFilter1);
      }
    }
  }


  GetSelectedDateAppts() {
    if (this.CurrentDoctorAppointmentsByDoctorcodeController.length > 0) {



      return this.CurrentDoctorAppointmentsByDoctorcodeController.
        filter(x => this.isSelectedDate(x.AppointmentDate));// .getFullYear == d);
      //.getFullYear() == this.SelectedFromDate.year &&
      //  x.AppointmentDate.getDay() == this.SelectedFromDate.day &&
      //  x.AppointmentDate.getMonth()+1 == this.SelectedFromDate.month)

    }
    return [];

  }

  Sel_ApptUpdtStatus(l: Appt) {
    const modalRef = this.modalService.open(NgbSel_ApptdetailsModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.xLocationCode = this.SelectedFacilityCode; 
    modalRef.componentInstance.ProviderCode = this.SelectedDoctorData.ProviderCode;
    modalRef.componentInstance.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    modalRef.componentInstance.AppointmentCode = l.ApptCode;
    modalRef.componentInstance.PatientName = l.PatientName;
    //modalRef.componentInstance.PatientFormattedCode = l.PatientFormattedCode;
    //modalRef.componentInstance.AppointmentCode = l.AppointmentCode;
    modalRef.componentInstance.Appt = l;
    

    //modalRef.componentInstance.CurrentDoctorAppointmentsByDoctorcode2Contoller = l;
    //modalRef.componentInstance.AppointmentCode = l.AppointmentCode;
    //modalRef.componentInstance.AppointmentStatus = l.AppointmentStatus;    
    //modalRef.componentInstance.Age = l.Age;
    //modalRef.componentInstance.Gender = l.Gender;
    //modalRef.componentInstance.Telephone1 = l.Telephone1;
    //modalRef.componentInstance.Email = l.Email;
    //modalRef.componentInstance.AppointmentDate = l.AppointmentDate;
    modalRef.result.then(() => {
      this.LoadDoctorAppointmentsByDoctor();
    });
  }

  isSelectedDate(da: any): boolean {
    var obj = new Date(da);// da as Date;
    //alert(obj.getFullYear());

    //var dat = new Date(obj.get .toDateString());

    var monthNo = this.SelectedFromDate.month;
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    if (obj.getFullYear() == this.SelectedFromDate.year &&
      obj.getMonth() + 1 == this.SelectedFromDate.month &&
      obj.getDate() == this.SelectedFromDate.day) {
      return true;
    }
    else {
      //alert(
      //  (obj.getFullYear()).toString() + ' <> ' + this.SelectedFromDate.year + ' : ' +
      //  (obj.getMonth() + 1).toString()  + ' <> '  + this.SelectedFromDate.month + ' : ' + 
      //  (obj.getDate()).toString() + ' <> ' + this.SelectedFromDate.day
      //);
      return false;
    }
    //return (obj.getFullYear() == this.SelectedFromDate.year &&
    //  obj.getMonth() + 1 == this.SelectedFromDate.month &&
    //  obj.getDay() == this.SelectedFromDate.day
    //  );
    //d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
  }
  onSubmit(l: DoctorAppointmentsByDoctorcode2Contoller, statusText: string, e) {

    var statusVal = e.target.checked;
    this.CurrentSavePatientVisitInformationRequest.ConditionalOperator = 10;
    this.CurrentSavePatientVisitInformationRequest.ActionItem = statusText;
    this.CurrentSavePatientVisitInformationRequest.ActionEvent = statusVal;

    this.CurrentSavePatientVisitInformationRequest.ActorCode = l.ActorCode;
    this.CurrentSavePatientVisitInformationRequest.ChekInTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.AppointmentCode = l.AppointmentCode;
    this.CurrentSavePatientVisitInformationRequest.AppointmentTime = new Date(l.AppointmentDate).toLocaleTimeString();
    this.CurrentSavePatientVisitInformationRequest.CheckOutTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.EncounterEndTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.VisitCode = l.PatientVisit;
    this.CurrentSavePatientVisitInformationRequest.ProviderSwapped = l.ProviderSwapped;
    this.CurrentSavePatientVisitInformationRequest.ProviderCode = l.ProviderCode;
    this.CurrentSavePatientVisitInformationRequest.AppointmentStatus = l.AppointmentStatus;

    this.actorservice.SavePatientVisitInformation(this.CurrentSavePatientVisitInformationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');


            this.LoadDoctorAppointmentsByDoctor();
            //this.LoadAppointmentDetailsByAppointmentCode(this.SelectedAppointmentDetails.AppointmentCode);
            //this.GetAppointmentDetailsByAppointmentCodeContoller();


            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //alertFunctions.AlertParamEr("ERROR - UNKNOWN.");

            this.stopRefreshing();
          }
        }
      );

  }
  DecrementDate(Value: any) {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));

    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //this.RefreshPatientsByDate();
    this.RefresAppts();

  }
  IncrementDate(Value: any) {
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));

    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };

    this.RefresAppts();

  }
  RefresAppts() {
    if (!this.CalendarView) {

      this._GetProviderAvlSlotsContoller(); // All slots of a day
      this.DisplayPresentDate = false;
      this.DisplaySelectedDate = true;
      this._GetDoctorAppointmentsByDoctorcodeContoller(); // Filled Slots


    }
    else {
      this.DisplayPresentDate = false;
      this.DisplaySelectedDate = true;
      // get slots => will call (get filled slots)
      this._GetProviderAvlSlotsForWeekContoller();



    }
  }
  cancel() {
    swal({
      title: 'Do You Want To Cancel Appoinment?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {

      this.CancelAppoinment();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  CancelAppoinment() {
    console.log('..................');
    //  this.StartRefreshing();
    this.CurrentAppointmentCancelRequest.ConditionalOperator = 15;
    this.CurrentAppointmentCancelRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAppointmentCancelRequest.AppointmentCode = this.SelectedAppointmentDetails.AppointmentCode;

    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveAppointmentInformation2(this.CurrentAppointmentCancelRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this._GetDoctorAppointmentsByDoctorcodeContoller();
            this._GetProviderAvlSlotsContoller();
            //this.Load
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();
            // this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }

  DailyView: boolean = true;
  CalendarView: boolean = false;
  SwitchView() {
    this.DailyView = !this.DailyView;
    this.CalendarView = !this.CalendarView;
    this.RefresAppts();
  }
  onSubmitIn() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 10;
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    //this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.clearDataIn();
            // this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            // this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            //this.activeModal.close();
            this.spinner.hide();
            // this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          // this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            // this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.spinner.hide();
            // this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.spinner.hide();
            //this.stopRefreshing();
          }
        }
      );

  }


  onDonor() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 10;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 11;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    // this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.clearDataDo();
            // this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            //this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            // this.activeModal.close();

            //this.stopRefreshing();

          }

        }
        else {
          //this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            //this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            // this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            // this.stopRefreshing();
          }
        }
      );

  }
  onCouple() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingAn));
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.FemaleDateofBirth = new Date(this.parserFormatter.format(this.FemaleDateofBirth));
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 30;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    // this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            this.spinner.hide();
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ClearCo();
            //this.activeModal.close();
            //this.router.navigate(['testnurse/profileview']);
            //this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            //this.activeModal.close();

            // this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            //this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            ///this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            //this.stopRefreshing();
          }
        }
      );

  }
  Profile(l: DoctorAppointmentsByDoctorcodeContoller) {
    this.router.navigate(['healins/profileview', { FormattedCode: l.PatientFormattedCode, DisplayName: l.PatientName, title: "App" }]);
  }
  Addbill(l: DoctorAppointmentsByDoctorcodeContoller) {
    this.router.navigate(['healins/receipt_svcprovider', { FormattedCode: l.PatientFormattedCode }]);
  }
  clearDataIn() {
    this.DateOfBirth = null;
    this.CurrentSavePatientInfoRequest.DisplayName = null;
    this.CurrentSavePatientInfoRequest.Gender = null;
    this.CurrentSavePatientInfoRequest.Telephone1 = null;
    this.CurrentSavePatientInfoRequest.AddressLine1 = null;
    this.CurrentSavePatientInfoRequest.Salutation = null;
  }
  clearDataDo() {
    this.DateOfBirth = null;
    this.CurrentSavePatientInfoRequest.DonorTypeName = null;
    this.CurrentSavePatientInfoRequest.DisplayName = null;
    this.CurrentSavePatientInfoRequest.Gender = null;
    this.CurrentSavePatientInfoRequest.Telephone1 = null;
    this.CurrentSavePatientInfoRequest.AddressLine1 = null;
    this.CurrentSavePatientInfoRequest.Salutation = null;
  }
  ClearCo() {
    this.FemaleDateofBirth = null;
    this.DateOfBirth = null;
    this.WeddingAn = null;
    this.CurrentSavePatientInfoRequest.DisplayName = null;
    this.CurrentSavePatientInfoRequest.Telephone1 = null;
    this.CurrentSavePatientInfoRequest.SalutationMale = null;
    this.CurrentSavePatientInfoRequest.Telephone1 = null;
    this.CurrentSavePatientInfoRequest.DisplayNameMale = null;
    this.CurrentSavePatientInfoRequest.MaleTelephone1 = null;
    this.CurrentSavePatientInfoRequest.AddressLine1 = null;
    this.CurrentSavePatientInfoRequest.Salutation = null;

  }

  SelectedFacilityCode: number;
  SelectedFacilityName: string;

  Roleassign(event: any) {

    if (event != null) {


      this.SelectedFacilityName = typeof event === 'string' ? event : event?.DisplayName;
      const facCode = Number(this.SelectedFacilityCode) || AppData.Instance().SelectedBranchCode || 1;
      this.LoadDoctorsList(facCode);
    }

  }

}
